import { Plan, Touchpoint } from '@/constants/enum';
import useConfirmationNavigate from '@/hooks/useConfirmationNavigate';
import useTrackTouchpoint from '@/hooks/useTrackTouchpoint';
import { dataSettingsSelector } from '@/redux/slice/settings.slice';
import { Badge } from '@shopify/polaris';
import { LockFilledIcon } from '@shopify/polaris-icons';
import { useSelector } from 'react-redux';

interface IProps {
  content: string;
  isVisible?: boolean;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  link?: {
    pathname: string;
    search: string;
  };
  touchpoint?: Touchpoint;
}

const BadgeWarning = ({ content, isVisible, icon, link, touchpoint }: IProps) => {
  const navigate = useConfirmationNavigate();
  const dataSettings = useSelector(dataSettingsSelector);
  const isShow = isVisible !== undefined ? isVisible : dataSettings.plan === Plan.FREE;

  const trackTouchPoint = useTrackTouchpoint();

  return isShow ? (
    <div
      onClick={() => {
        link && navigate(link);
        if (touchpoint) {
          trackTouchPoint(touchpoint);
        }
      }}
      style={{ cursor: 'pointer', marginLeft: '0.5rem' }}
    >
      <Badge tone="info" size="medium" icon={icon || LockFilledIcon}>
        {content}
      </Badge>
    </div>
  ) : null;
};

export default BadgeWarning;
